import React, { useState, useEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  formateDate,
  getEndOfMonth,
  GetSelectedIDsFromList,
  getStartOfMonth,
} from "../Shared/Utility";
import { useGlobalState } from "../Context/GlobalStateContext";

function MaterialsJobs() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [clearFilters, setClearFilters] = useState(false);
  const [materialsJobsObject, setMaterialsJobsObject] = useState({
    EndDate: "",
    JobID: "",
    MNVMoverID: 0,
    StartDate: "",
    EarningsView: true,
    Total: 0,
  });

  const [gridData, setGridData] = useState<any>([]);

  useEffect(() => {
    ClearFilters(false);
  }, [clearFilters]);

  useEffect(() => {
    if (isFirstTime && materialsJobsObject.StartDate != "") {
      setIsFirstTime(false);
      getMaterialsJobsData();
    }
  }, [materialsJobsObject]);

  function ClearFilters(clear: boolean) {
    var l_oToday = new Date();

    setMaterialsJobsObject((prevState: any) => ({
      ...prevState,
      StartDate: new Date(
        l_oToday.getFullYear(),
        l_oToday.getMonth() - 7,
        0,
        0,
        0,
        0,
        0,
      ).toLocaleDateString("en-CA"),
      EndDate: new Date(
        l_oToday.getFullYear(),
        l_oToday.getMonth() + 1,
        0,
        0,
        0,
        0,
        0,
      ).toLocaleDateString("en-CA"),
      JobID: "",
    }));
    if (clear == true) setClearFilters(!clearFilters);
  }

  function getMaterialsJobsData() {
    setIsAnimation(true);
    let object = materialsJobsObject;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteGetAllJobsThatInvolveMaterials",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setGridData(l_response[0]);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}

      <>
        <div className="flex-d justify-btw flex-gap10">
          <div className="flex-da flex-gap10">
            <div className="field-input">
              <input
                type="text"
                title="Job ID"
                placeholder="Job ID"
                value={materialsJobsObject.JobID}
                onChange={(e) =>
                  setMaterialsJobsObject((prevState: any) => ({
                    ...prevState,
                    JobID: e.target.value,
                  }))
                }
                className="input-field"
              />
            </div>
            <div className="field-input date-field">
              <input
                type="date"
                title="Start Date"
                placeholder="Start Date"
                value={materialsJobsObject.StartDate}
                onChange={(e) =>
                  setMaterialsJobsObject((prevState: any) => ({
                    ...prevState,
                    StartDate: e.target.value,
                  }))
                }
                className="input-field"
              />
            </div>
            <div className="field-input date-field">
              <input
                type="date"
                title="End Date"
                placeholder="End Date"
                value={materialsJobsObject.EndDate}
                onChange={(e) =>
                  setMaterialsJobsObject((prevState: any) => ({
                    ...prevState,
                    EndDate: e.target.value,
                  }))
                }
                className="input-field"
              />
            </div>

            <div className="flex-daj btn-start flex-gap10">
              <a
                onClick={() => ClearFilters(true)}
                className="btn-primary flex-daj"
              >
                Clear Filters
              </a>
              <a
                onClick={() => getMaterialsJobsData()}
                className="btn-primary flex-daj"
              >
                Filter
              </a>
            </div>
          </div>

          <div className="flex-d btn-start flex-gap10">
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcel(
                  "tblmarketingscore",
                  "Materials Jobs",
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
        </div>
        <div className="flow-auto mt-10">
          <table className="reuse-table" id="tblmarketingscore">
            <thead>
              <tr>
                <th>Job ID</th>
                <th>Date</th>
                <th>Number Of Boxes Used</th>
                <th>Notes</th>
                <th>Is Boxes Refund Done</th>
              </tr>
            </thead>
            <tbody>
              {gridData &&
                gridData.map((Item: any, index: any) => (
                  <React.Fragment key={index}>
                    <tr key={index}>
                      <td>
                        <a
                          href={
                            Item?.MNVJobID
                              ? `/quote_detail/${Item.MNVJobID}`
                              : "#"
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            if (!Item?.MNVJobID) {
                              e.preventDefault();
                              return;
                            }
                          }}
                        >
                          {Item.JobID}
                        </a>
                      </td>
                      <td>{formateDate(Item.RequestedDate)}</td>
                      <td>{Item.NumberOfBoxes}</td>
                      <td>{Item.MoverNotesForMaterials}</td>
                      <td>{Item.IsBoxesReturned}</td>
                    </tr>
                  </React.Fragment>
                ))}
            </tbody>
          </table>
        </div>
      </>
    </div>
  );
}

export default MaterialsJobs;
